(ns dashboard.dev-mode
  (:require [re-frame.core :as rf]))

(rf/reg-event-db
  ::set-option
  (fn [db [_ ks v]]
    (assoc-in db (into [:dev-mode] ks) v)))


(rf/reg-sub
  ::get-option
  (fn [db [_ ks]]
    (get-in db (into [:dev-mode] ks))))
